import { useEffect } from 'react';
import PropTypes from 'prop-types';
import useChart from '../UseChart';

var Debug = function Debug(_ref) {
  var _ref$varName = _ref.varName,
      varName = _ref$varName === void 0 ? 'chart' : _ref$varName;
  var chart = useChart();
  useEffect(function () {
    window[varName] = chart.object; // eslint-disable-next-line no-console

    console.log("Chart instance available as global variable as window.".concat(varName));
    return function () {
      window[varName] = undefined;
    };
  }, [varName]);
  return null;
};

Debug.propTypes = {
  varName: PropTypes.string
};
export default Debug;